/** Elite Pulse trading-call confidence: 3-tier bands + Arabic labels. */

export type ConfidenceTier = 'high' | 'medium' | 'low';

export function confidenceTierFromPct(pct: number | null | undefined): ConfidenceTier {
  const p = Number(pct);
  if (!Number.isFinite(p)) return 'medium';
  if (p >= 70) return 'high';
  if (p >= 50) return 'medium';
  return 'low';
}

export function parseTradingCallConfidencePct(call: {
  confidencePct?: number;
  confidence_pct?: number;
  confidence?: string;
}): number | null {
  const direct = call.confidencePct ?? call.confidence_pct;
  if (direct != null && Number.isFinite(Number(direct))) {
    return Math.max(0, Math.min(100, Number(direct)));
  }
  const raw = String(call.confidence ?? '').trim();
  const m = raw.match(/(\d+(?:\.\d+)?)\s*%?/);
  if (m) return Math.max(0, Math.min(100, Number(m[1])));
  if (/^high$/i.test(raw)) return 75;
  if (/^medium$/i.test(raw)) return 60;
  if (/^low$/i.test(raw)) return 40;
  return null;
}

const TIER_AR: Record<ConfidenceTier, string> = {
  high: 'عالية',
  medium: 'متوسطة',
  low: 'منخفضة',
};

export function formatConfidenceAr(pct: number | null | undefined): string {
  if (pct == null || !Number.isFinite(Number(pct))) return 'ثقة غير محددة';
  const p = Math.round(Number(pct));
  const tier = confidenceTierFromPct(p);
  return `ثقة ${TIER_AR[tier]} (${p}٪)`;
}

export function formatConfidenceEn(pct: number | null | undefined): string {
  if (pct == null || !Number.isFinite(Number(pct))) return 'confidence n/a';
  const p = Math.round(Number(pct));
  const tier = confidenceTierFromPct(p);
  return `${tier} (${p}%)`;
}

export function confidenceBadgeColor(tier: ConfidenceTier): 'green' | 'yellow' | 'gray' {
  if (tier === 'high') return 'green';
  if (tier === 'medium') return 'yellow';
  return 'gray';
}
